module.exports = __webpack_public_path__ + "static/img/bg_section_about_us.989a42b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_section_about_us.jpg
// module id = Gzgi
// module chunks = 3